import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OtpAuthService {
	private smsIdKey = 'validatedSmsId';
	private otpKey = 'validatedOtp';

	markValidated(smsId: number, otp: string) {
		sessionStorage.setItem(this.smsIdKey, smsId.toString());
		sessionStorage.setItem(this.otpKey, otp);
	}

	isValidated(): boolean {
		return sessionStorage.getItem(this.smsIdKey) !== null 
			&& sessionStorage.getItem(this.otpKey) !== null;
	}

	getSmsId(): number | null {
		const value = sessionStorage.getItem(this.smsIdKey);
    	return value ? Number(value) : null;
	}

	getOtp(): string | null {
		return sessionStorage.getItem(this.otpKey);
	}

	clear() {
		sessionStorage.removeItem(this.smsIdKey);
		sessionStorage.removeItem(this.otpKey);
	}
}